"use client"

import type { ReactNode } from "react"
import { AuthProvider } from "@/features/auth/auth-provider"
import { ThemeProvider } from "@/shared/components/theme-provider"
import { QueryProvider } from "@/shared/providers/query-provider"

/**
 * Providers required by interactive product surfaces.
 *
 * Keeping these below route-group layouts prevents content-only routes such as
 * the blog from downloading and hydrating the app's auth/query stack.
 */
export function ProductProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AuthProvider>{children}</AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  )
}
